import React from "react";
import "./circle.css";
const CirlceHlt = props => {
  return (
    <div
      className="cwp"
      style={{ width: "100%", paddingBottom: "10px", paddingTop: "24px" }}
      tabIndex="-1"
    >
      <div
        tabIndex="-1"
        className="circleWhite"
        style={{
          borderRadius: "50%",
          color: "#007155",
          fontSize: "70px",
          fontFamily: "Oswald",
          height: "210px",
          width: "210px",
          display: "block",
          marginLeft: "15px",
          marginRight: "auto",
          marginTop: "-40px",
          position: "relative"
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
CirlceHlt.defaultProps = {
  children: "No Data For Slide"
};
export default CirlceHlt;
